/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Sync_Col_Remote_IdInputs */

const cs_portals_sync_col_remote_id = /** @type {(inputs: Portals_Sync_Col_Remote_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vzdálené ID`)
};

const en_portals_sync_col_remote_id = /** @type {(inputs: Portals_Sync_Col_Remote_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remote ID`)
};

/**
* | output |
* | --- |
* | "Remote ID" |
*
* @param {Portals_Sync_Col_Remote_IdInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_sync_col_remote_id = /** @type {((inputs?: Portals_Sync_Col_Remote_IdInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Sync_Col_Remote_IdInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_sync_col_remote_id(inputs)
	return cs_portals_sync_col_remote_id(inputs)
});